import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Button, Paper, Grid, Snackbar, CircularProgress } from '@mui/material';
import { obterClasse, excluirClasse } from '../../services/classeService';

const DetalhesClassePage = () => {
  const [classe, setClasse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClasse = async () => {
      try {
        setLoading(true);
        const data = await obterClasse(id);
        setClasse(data);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao buscar detalhes da classe:', error);
        setError('Erro ao carregar detalhes da classe');
        setLoading(false);
        setSnackbarMessage('Erro ao carregar detalhes da classe');
        setOpenSnackbar(true);
      }
    };

    fetchClasse();
  }, [id]);

  const handleExcluir = async () => {
    // ... (código de exclusão permanece o mesmo)
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (!classe) {
    return <Typography>Classe não encontrada</Typography>;
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Classe {classe.numero}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography><strong>Descrição:</strong> {classe.descricao || 'Não disponível'}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography><strong>Campanha:</strong> {classe.campanha?.nome || 'Não associada'}</Typography>
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(`/classes/editar/${id}`)}
        sx={{ mt: 2, mr: 1 }}
      >
        Editar
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={handleExcluir}
        sx={{ mt: 2 }}
      >
        Excluir
      </Button>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
      />
    </Paper>
  );
};

export default DetalhesClassePage;